import type { ImportBalancesRepositoryT } from "../../domain/ports/importBalances.repository";

type ImportBalancesParamsT = {
  importBalancesRepository: ImportBalancesRepositoryT;
  colaboraInstanceId: string;
  typeId: string;
  mode: "all" | "no-balances";
  externalTypeId: number;
};

export const importBalances = ({
  importBalancesRepository,
  colaboraInstanceId,
  typeId,
  mode,
  externalTypeId,
}: ImportBalancesParamsT) =>
  importBalancesRepository.importBalances({
    colaboraInstanceId,
    typeId,
    mode,
    externalTypeId,
  });
